import { render, staticRenderFns } from "./MainStatistics.vue?vue&type=template&id=6e7df3ce&"
import script from "./MainStatistics.vue?vue&type=script&lang=js&"
export * from "./MainStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports